import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

// TODO: fix type
interface Props {
  data: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RichVideo',
  props: {
    data: null
  },
  setup(__props: any) {



const isShown = ref(false);
const activeVideo = ref(0);
const show = () => {
  isShown.value = true;
};

const setActiveVideo = (index: number) => {
  isShown.value = false;
  activeVideo.value = index;
};

return { __sfc: true,isShown, activeVideo, show, setActiveVideo }
}

})